import React from "react";
import "./Rajesh.css"; // Import the CSS
import rajesh_adapa from "../../../assets/images/rajesh_adapa.png";
import { Helmet } from "react-helmet";

const RajeshProfile = () => {
  return (
    <div>
      <Helmet>
        <title>
          {" "}
          Rajesh Adapa - Sr. Technical Architect | Cyber Security Strategy and Architecture at
          Idexcel
        </title>
        <meta content="" name="keywords" />
        <meta
          content="In order to be the leader of a high-performing business team, you must encourage others and set clear goals. Meet our leadership team here."
          name="description"
        />
      </Helmet>
      <div className="empty"></div>
      <div className="rajesh-container">
        <div className="rajesh-image">
          <img src={rajesh_adapa} alt="Rajesh" style={{ width: "300px" }} />
        </div>
        <div className="rajesh-content">
          <h2 className="fw-semibold text-black m-0 mb-1 mt-2">
            Venkata Rajesh Krishna Adapa (Rajesh Adapa)
          </h2>
          <h4 className="fw-medium text-black m-0">
          Sr. Technical Architect | Cyber Security Strategy and Architecture
          </h4>
          <p className="mt-3">
            Since joining Idexcel in 2017, Rajesh has been instrumental in
            driving the company’s cybersecurity strategy and architecture. A
            Gold Medalist from Jawaharlal Nehru Technological University,
            Hyderabad, India, he brings 19 years of IT industry experience, with
            a strong focus on developing enterprise-level security solutions.
            Rajesh excels at creating robust security frameworks that protect
            critical digital assets while ensuring compliance with industry
            standards and regulations. His leadership in aligning technical
            initiatives with broader business goals ensures that clients are
            well-prepared to navigate complex security challenges and emerging
            threats. Known for his innovative approach to security, he has been
            key in implementing solutions that foster operational excellence and
            long-term resilience for clients across various industries. Outside
            of work, Rajesh actively engages in exploring the latest technology
            trends and contributing to community initiatives focused on cyber
            awareness.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RajeshProfile;
